<template>
  <div>
    <h2>Upload vagtskema</h2>
    <ion-label>Vil du opdatere vagtskema?</ion-label>
    <br />
    <input
      type="file"
      id="fileInput"
      ref="file"
      accept=".csv"
      @change="fileReader()"
    />
    <hr />
    {{ data.length }} / {{ csvArray.length }}

    <hr />
    <div v-if="fileDone">
      <ion-button expand="block" @click="saveWorkPlanData()"
        >Gem data</ion-button
      >
    </div>
    <br />
    <ion-label color="primary" v-if="message.length > 0">{{
      message
    }}</ion-label>
  </div>
</template>

<script>
import Papa from "papaparse";

import { mapGetters } from "vuex";
import { IonButton, IonLabel } from "@ionic/vue";

export default {
  components: {
    IonButton,
    IonLabel,
  },
  data() {
    return {
      fileDone: false,
      fileName: "",
      csvArray: [],
      data: [],
      message: "",
    };
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    saveWorkPlanData() {
      var app = this;
      if (this.data.length === 0) {
        this.message =
          "Filen mangler data eller kolonnen 'Dato' - intet er gemt, eksisterende vagtskema er uændret.";
        return;
      }
      this.$store.commit("saveWorkPlanData", this.data);

      var result = this.$store.dispatch("saveToBlobStorage", {
        data: this.data,
        blobName: "work",
      });

      result.then(function(data) {
        app.message = data;
      });
    },
    fileReader() {
      var app = this;
      this.loading = true;
      var oFile = this.$refs.file.files[0];

      //reset
      this.data = [];
      this.csvArray = [];
      this.fileDone = false;
      this.message = "";

      Papa.parse(oFile, {
        header: true,
        download: true,
        dynamicTyping: true,
        encoding: "UTF-8",
        skipEmptyLines: "greedy",
        transformHeader: (h) => h.replace(/^\ufeff/, ""),
        complete: function(results) {
          app.csvArray = results.data;

          // Rækker uden Dato (fx tomme rækker i bunden af Excel-filen) ignoreres
          app.data = app.csvArray.filter((x) => x.Dato);
          app.fileDone = app.data.length > 0;
        },
      });
    },
  },
};
</script>
